import {Calendar} from 'vanilla-calendar-pro';

const CALENDAR_LAYOUT_WITH_TIME = `
    <div class="vc-header" data-vc="header" role="toolbar" aria-label="Calendar Navigation">
        <#ArrowPrev />
        <div class="vc-header__content" data-vc-header="content">
            <#Month />
            <#Year />
        </div>
        <#ArrowNext />
    </div>
    <div class="vc-wrapper" data-vc="wrapper">
        <#WeekNumbers />
        <div class="vc-content" data-vc="content">
            <#Week />
            <#Dates />
            <#DateRangeTooltip />
        </div>
    </div>
    <#ControlTime />
    <button id="btn-close" class="
        mt-3 px-5 py-2 rounded-md border text-sm font-medium
        transition duration-200 shadow-sm
        bg-white text-gray-700 border-gray-300
        hover:bg-gray-100 hover:border-gray-400 hover:scale-[1.02]
        dark:bg-gray-800 dark:text-gray-100 dark:border-gray-600
        dark:hover:bg-gray-700 dark:hover:border-gray-500
        focus:outline-none focus:ring-1 focus:ring-blue-500 focus:ring-offset-2
        dark:focus:ring-offset-gray-900" type="button">
        ${CONFIG.i18n.validate}
    </button>
`;

/**
 * Initializes calendar inputs with vanilla-calendar-pro
 * @param {HTMLElement} root - Root element to search within
 */
export function init(root) {
    window.Calendar = Calendar;

    root.querySelectorAll('input[type^="date"]').forEach((input) => {
        const options = buildCalendarOptions(input);
        const calendar = new Calendar(input, options);
        calendar.init();
    });
}

/**
 * Builds calendar configuration options
 */
function buildCalendarOptions(input) {
    const hasTimeSelection = input.type === 'datetime-local';

    const options = {
        type: 'default',
        positionToInput: 'auto',
        selectionTimeMode: hasTimeSelection ? 24 : false,
        inputMode: true,
        locale: 'fr',
        onChangeToInput: (self) => handleDateChange(self),
        onInit: (self) => handleCalendarInit(self)
    };

    if (hasTimeSelection) {
        options.layouts = {
            default: CALENDAR_LAYOUT_WITH_TIME
        };
    }

    return options;
}

/**
 * Handles date change events
 */
function handleDateChange(calendar) {
    if (!calendar.context.inputElement || calendar.selectionTimeMode) return;

    const selectedDate = calendar.context.selectedDates[0];
    calendar.context.inputElement.value = selectedDate || '';

    if (selectedDate) {
        calendar.hide();
    }
}

/**
 * Handles calendar initialization for datetime inputs
 */
function handleCalendarInit(calendar) {
    if (!calendar.selectionTimeMode) return;

    const handleClick = (event) => {
        if (event.target.closest('#btn-close')) {
            let selectedDate = calendar.context.selectedDates[0] || '';

            if (calendar.selectionTimeMode && selectedDate) {
                const {selectedHours, selectedMinutes} = calendar.context;
                selectedDate += ` ${selectedHours}:${selectedMinutes}`;
            }

            calendar.context.inputElement.value = selectedDate;
            calendar.hide();
        }
    };

    calendar.context.mainElement.addEventListener('click', handleClick);

    return () => {
        calendar.context.mainElement.removeEventListener('click', handleClick);
    };
}